import { render, staticRenderFns } from "./PackageBox.vue?vue&type=template&id=5698b92c&scoped=true&"
import script from "./PackageBox.vue?vue&type=script&lang=js&"
export * from "./PackageBox.vue?vue&type=script&lang=js&"
import style0 from "./PackageBox.vue?vue&type=style&index=0&id=5698b92c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5698b92c",
  null
  
)

export default component.exports